module.exports = __webpack_public_path__ + "img/ltkfindsunder50-2x.19120ee.jpg";